import { Link } from "react-router-dom";
import { footerGroups } from "@/mocks/navigation";
import { clinic } from "@/mocks/clinic";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-800 pb-24 pt-16 text-background-100 lg:pb-10 md:pt-20">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1.1fr_1.6fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="font-label text-2xl tracking-[0.22em] text-background-50">SBDC</span>
              <span className="h-6 w-px bg-background-50/25" />
              <span className="text-[10px] leading-[1.5] tracking-wider text-background-200">
                渋谷美容皮膚科
                <br />
                クリニック
              </span>
            </div>
            <p className="mt-6 max-w-xs text-[12px] leading-[2] text-background-200/80">
              一人ひとりの悩みに寄り添い、納得できる美容医療をご提案します。
            </p>
            <div className="mt-7 space-y-1.5 text-[12px] leading-relaxed text-background-200/85">
              <p>{clinic.postal}　{clinic.address}</p>
              <p>TEL {clinic.tel}（{clinic.hours}）</p>
            </div>
            <a
              href={clinic.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-[12px] text-background-200 transition-colors hover:text-background-50"
            >
              <i className="ri-instagram-line text-base" aria-hidden />
              Instagram
            </a>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h3 className="en-eyebrow text-[10px] text-background-50">{group.title}</h3>
                <span className="mt-4 block h-px w-6 bg-accent-400" />
                <ul className="mt-5 space-y-3">
                  {group.links.map((link) => {
                    const isExternal = link.href.startsWith("http");
                    return (
                      <li key={link.label}>
                        {isExternal ? (
                          <a
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[12px] text-background-200/85 transition-colors hover:text-background-50"
                          >
                            {link.label}
                          </a>
                        ) : (
                          <Link
                            to={link.href}
                            className="text-[12px] text-background-200/85 transition-colors hover:text-background-50"
                          >
                            {link.label}
                          </Link>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-background-50/15 pt-7 text-[11px] text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} SHIBUYA BEAUTY DERMATOLOGY CLINIC. All rights reserved.</p>
          <p className="text-background-200/60">
            美容医療は自由診療です。効果・経過には個人差があります。
          </p>
        </div>
      </div>
    </footer>
  );
}